var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.buscarButton,
            expression: "buscarButton"
          }
        ],
        staticClass: "card"
      },
      [
        _c("div", { staticClass: "card__content" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row mb-0" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.createButton,
                        expression: "createButton"
                      }
                    ],
                    staticClass: "col-xs-12"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn-success btn--bigger",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.currentIndex = -1
                            _vm.crear()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-external-link" }),
                        _c("span", [_vm._v("Crear")])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12",
                    class: {
                      "my-2":
                        !_vm.form.buscarNumero &&
                        _vm.createButton &&
                        _vm.esComprobante,
                      "mb-3": !_vm.createButton && !_vm.form.buscarNumero
                    }
                  },
                  [
                    _c(
                      "div",
                      { class: { "form-inline": _vm.form.buscarNumero } },
                      [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante || _vm.buscarNumero,
                                expression: "esComprobante || buscarNumero"
                              }
                            ],
                            staticClass: "mb-0"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.buscarNumero,
                                  expression: "form.buscarNumero"
                                }
                              ],
                              attrs: { type: "checkbox", id: "buscarNumero" },
                              domProps: {
                                checked: Array.isArray(_vm.form.buscarNumero)
                                  ? _vm._i(_vm.form.buscarNumero, null) > -1
                                  : _vm.form.buscarNumero
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.form.buscarNumero,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.form,
                                          "buscarNumero",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.form,
                                          "buscarNumero",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.form, "buscarNumero", $$c)
                                  }
                                }
                              }
                            }),
                            _c("span", [_vm._v("Buscar por número")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.buscarNumero,
                                expression: "form.buscarNumero"
                              }
                            ],
                            staticClass: "form-group"
                          },
                          [
                            _c("input-field", {
                              attrs: {
                                id: "numeroDocumento",
                                placeholder: "Número"
                              },
                              model: {
                                value: _vm.form.numero_documento,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "numero_documento", $$v)
                                },
                                expression: "form.numero_documento"
                              }
                            }),
                            _vm._v(" "),
                            _vm._m(0)
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.esComprobante &&
                                  _vm.filterStatus &&
                                  !_vm.form.buscarNumero,
                                expression:
                                  "!esComprobante && filterStatus && !form.buscarNumero"
                              }
                            ],
                            staticClass: "form-inline row mb-0 mt-3"
                          },
                          [
                            _c("div", { staticClass: "col-xs-12 col-lg-1" }, [
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.esComprobante &&
                                        _vm.filterStatus &&
                                        !_vm.form.buscarNumero,
                                      expression:
                                        "\n                      !esComprobante && filterStatus && !form.buscarNumero\n                    "
                                    }
                                  ]
                                },
                                [_vm._m(1)]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-12 col-lg-10" }, [
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.esComprobante &&
                                        !_vm.form.buscarNumero,
                                      expression:
                                        "!esComprobante && !form.buscarNumero"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.filterStatus,
                                          expression: "filterStatus"
                                        }
                                      ]
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.status,
                                            expression: "form.status"
                                          }
                                        ],
                                        attrs: { type: "radio", value: "A" },
                                        domProps: {
                                          checked: _vm._q(_vm.form.status, "A")
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              return _vm.$set(
                                                _vm.form,
                                                "status",
                                                "A"
                                              )
                                            },
                                            _vm.submit
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.tipoDocumento === "EG" ||
                                              _vm.tipoDocumento === "ND" ||
                                              _vm.tipoDocumento == "NC" ||
                                              _vm.tipoDocumento === "IN" ||
                                              _vm.tipoDocumento === "CR"
                                              ? "Emitido"
                                              : "Activos(as)"
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.esComprobante &&
                                        _vm.tipoDocumento != "CR",
                                      expression:
                                        "!esComprobante && tipoDocumento != 'CR'"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.filterStatus,
                                          expression: "filterStatus"
                                        }
                                      ]
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.status,
                                            expression: "form.status"
                                          }
                                        ],
                                        attrs: { type: "radio", value: "I" },
                                        domProps: {
                                          checked: _vm._q(_vm.form.status, "I")
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              return _vm.$set(
                                                _vm.form,
                                                "status",
                                                "I"
                                              )
                                            },
                                            _vm.submit
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.tipoDocumento === "EG" ||
                                              _vm.tipoDocumento === "ND" ||
                                              _vm.tipoDocumento == "NC" ||
                                              _vm.tipoDocumento == "IN"
                                              ? "Conciliado"
                                              : "Inactivo(as)"
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.esComprobante &&
                                        (_vm.tipoDocumento === "EG" ||
                                          _vm.tipoDocumento === "ND" ||
                                          _vm.tipoDocumento == "NC" ||
                                          _vm.tipoDocumento == "IN" ||
                                          _vm.tipoDocumento === "CR"),
                                      expression:
                                        "\n                      !esComprobante &&\n                      (tipoDocumento === 'EG' ||\n                        tipoDocumento === 'ND' ||\n                        tipoDocumento == 'NC' ||\n                        tipoDocumento == 'IN' ||\n                        tipoDocumento === 'CR')\n                    "
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.filterStatus,
                                          expression: "filterStatus"
                                        }
                                      ]
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.status,
                                            expression: "form.status"
                                          }
                                        ],
                                        attrs: { type: "radio", value: "AN" },
                                        domProps: {
                                          checked: _vm._q(_vm.form.status, "AN")
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              return _vm.$set(
                                                _vm.form,
                                                "status",
                                                "AN"
                                              )
                                            },
                                            _vm.submit
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Anulado")])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.esComprobante,
                                      expression: "!esComprobante"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.filterStatus,
                                          expression: "filterStatus"
                                        }
                                      ]
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.status,
                                            expression: "form.status"
                                          }
                                        ],
                                        attrs: { type: "radio", value: "T" },
                                        domProps: {
                                          checked: _vm._q(_vm.form.status, "T")
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              return _vm.$set(
                                                _vm.form,
                                                "status",
                                                "T"
                                              )
                                            },
                                            _vm.submit
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Todos(as)")])
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.buscarNumero && _vm.esComprobante,
                        expression: "!form.buscarNumero && esComprobante"
                      }
                    ],
                    staticClass: "col-xs-12"
                  },
                  [
                    _c("div", { staticClass: "form-inline row" }, [
                      _c("div", { staticClass: "col-xs-12 col-lg-1" }, [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [_vm._m(2)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-lg-10" }, [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.status,
                                  expression: "form.status"
                                }
                              ],
                              attrs: { type: "radio", value: "T" },
                              domProps: {
                                checked: _vm._q(_vm.form.status, "T")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "status", "T")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Todos")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.status,
                                  expression: "form.status"
                                }
                              ],
                              attrs: { type: "radio", value: "P" },
                              domProps: {
                                checked: _vm._q(_vm.form.status, "P")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "status", "P")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Pendientes de aprobación")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.status,
                                  expression: "form.status"
                                }
                              ],
                              attrs: { type: "radio", value: "E" },
                              domProps: {
                                checked: _vm._q(_vm.form.status, "E")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "status", "E")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Emitidos")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.esComprobante &&
                                  _vm.form.tipo_comprobante === "T" &&
                                  !_vm.form.buscarNumero &&
                                  _vm.tipoDocumento != "CO",
                                expression:
                                  "\n                    esComprobante &&\n                    form.tipo_comprobante === 'T' &&\n                    !form.buscarNumero &&\n                    tipoDocumento != 'CO'\n                  "
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.status,
                                  expression: "form.status"
                                }
                              ],
                              attrs: { type: "radio", value: "AUT" },
                              domProps: {
                                checked: _vm._q(_vm.form.status, "AUT")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "status", "AUT")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Autorizadas")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.status,
                                  expression: "form.status"
                                }
                              ],
                              attrs: { type: "radio", value: "NAT" },
                              domProps: {
                                checked: _vm._q(_vm.form.status, "NAT")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "status", "NAT")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("No autorizadas")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.status,
                                  expression: "form.status"
                                }
                              ],
                              attrs: { type: "radio", value: "A" },
                              domProps: {
                                checked: _vm._q(_vm.form.status, "A")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "status", "A")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Anuladas")])
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.buscarNumero && _vm.esComprobante,
                        expression: "!form.buscarNumero && esComprobante"
                      }
                    ],
                    staticClass: "col-xs-12"
                  },
                  [
                    _c("div", { staticClass: "form-inline row" }, [
                      _c("div", { staticClass: "col-xs-12 col-lg-1" }, [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [_vm._m(3)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-lg-10" }, [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.formato,
                                  expression: "form.formato"
                                }
                              ],
                              attrs: { type: "radio", value: "M" },
                              domProps: {
                                checked: _vm._q(_vm.form.formato, "M")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "formato", "M")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Manual")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.formato,
                                  expression: "form.formato"
                                }
                              ],
                              attrs: { type: "radio", value: "E" },
                              domProps: {
                                checked: _vm._q(_vm.form.formato, "E")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "formato", "E")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Electrónica")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante,
                                expression: "esComprobante"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.formato,
                                  expression: "form.formato"
                                }
                              ],
                              attrs: { type: "radio", value: "T" },
                              domProps: {
                                checked: _vm._q(_vm.form.formato, "T")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "formato", "T")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Todas")])
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.form.buscarNumero &&
                          (_vm.esComprobante || _vm.fechas),
                        expression:
                          "!form.buscarNumero && (esComprobante || fechas)"
                      }
                    ],
                    staticClass: "col-xs-12"
                  },
                  [
                    _c("div", { staticClass: "form-inline row mb-0" }, [
                      _c("div", { staticClass: "col-xs-12 col-lg-1" }, [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante || _vm.fechas,
                                expression: "esComprobante || fechas"
                              }
                            ]
                          },
                          [_vm._m(4)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-lg-11" }, [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante || _vm.fechas,
                                expression: "esComprobante || fechas"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.tipo_fecha,
                                  expression: "form.tipo_fecha"
                                }
                              ],
                              attrs: { type: "radio", value: "H" },
                              domProps: {
                                checked: _vm._q(_vm.form.tipo_fecha, "H")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "tipo_fecha", "H")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Hoy")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante || _vm.fechas,
                                expression: "esComprobante || fechas"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.tipo_fecha,
                                  expression: "form.tipo_fecha"
                                }
                              ],
                              attrs: { type: "radio", value: "A" },
                              domProps: {
                                checked: _vm._q(_vm.form.tipo_fecha, "A")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "tipo_fecha", "A")
                                  },
                                  _vm.submit
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Ayer")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.esComprobante || _vm.fechas,
                                expression: "esComprobante || fechas"
                              }
                            ]
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.tipo_fecha,
                                  expression: "form.tipo_fecha"
                                }
                              ],
                              attrs: { type: "radio", value: "P" },
                              domProps: {
                                checked: _vm._q(_vm.form.tipo_fecha, "P")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(_vm.form, "tipo_fecha", "P")
                                  },
                                  _vm.cambiarPersonalizado
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Personalizado")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  (_vm.esComprobante &&
                                    _vm.form.tipo_fecha === "P") ||
                                  (_vm.fechas && _vm.form.tipo_fecha === "P"),
                                expression:
                                  "\n                    (esComprobante && form.tipo_fecha === 'P') ||\n                    (fechas && form.tipo_fecha === 'P')\n                  "
                              }
                            ],
                            staticClass: "form-field"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "datepicker-field datepicker-field--stretch"
                              },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    type: "date",
                                    format: "dd-MM-yyyy",
                                    id: "desde",
                                    lang: "es"
                                  },
                                  model: {
                                    value: _vm.form.fecha_desde,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "fecha_desde", $$v)
                                    },
                                    expression: "form.fecha_desde"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Desde")]),
                                _vm._v(" "),
                                _vm.errores.fecha_desde
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.errores.fecha_desde[0])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  (_vm.esComprobante &&
                                    _vm.form.tipo_fecha === "P") ||
                                  (_vm.fechas && _vm.form.tipo_fecha === "P"),
                                expression:
                                  "\n                    (esComprobante && form.tipo_fecha === 'P') ||\n                    (fechas && form.tipo_fecha === 'P')\n                  "
                              }
                            ],
                            staticClass: "form-field"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "datepicker-field datepicker-field--stretch"
                              },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    type: "date",
                                    format: "dd-MM-yyyy",
                                    id: "hasta",
                                    lang: "es"
                                  },
                                  model: {
                                    value: _vm.form.fecha_hasta,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "fecha_hasta", $$v)
                                    },
                                    expression: "form.fecha_hasta"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Hasta")]),
                                _vm._v(" "),
                                _vm.errores.fecha_hasta
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.errores.fecha_hasta[0])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.verTipoComprobante && !_vm.form.buscarNumero,
                        expression: "verTipoComprobante && !form.buscarNumero"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-3"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field select2-field--stretch" },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "tipo_comprobante",
                              placeholder: "Seleccione",
                              options: _vm.options_tipo_comprobante,
                              label: "descripcion"
                            },
                            on: { onChange: _vm.submit },
                            model: {
                              value: _vm.selected_tipo_comprobante,
                              callback: function($$v) {
                                _vm.selected_tipo_comprobante = $$v
                              },
                              expression: "selected_tipo_comprobante"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "tipo_comprobante" } }, [
                            _vm._v("Tipo de comprobante")
                          ]),
                          _vm._v(" "),
                          _vm.errores.tipo_comprobante
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.tipo_comprobante[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.esComprobanteContable,
                        expression: "esComprobanteContable"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-2"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field select2-field--stretch" },
                        [
                          _c("v-select", {
                            attrs: { options: _vm.tipos, label: "tipo" },
                            model: {
                              value: _vm.selectedTipo,
                              callback: function($$v) {
                                _vm.selectedTipo = $$v
                              },
                              expression: "selectedTipo"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "tipo" } }, [
                            _vm._v("Tipo:")
                          ])
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.buscarNumero,
                        expression: "!form.buscarNumero"
                      }
                    ],
                    staticClass: "col-xs-12",
                    class: {
                      "col-md-9": _vm.verTipoComprobante,
                      "col-md-10": _vm.esComprobanteContable
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.buscarButton,
                            expression: "buscarButton"
                          }
                        ],
                        staticClass: "form-group"
                      },
                      [
                        _c("input-field", {
                          attrs: {
                            stretch: "",
                            id: "buscar",
                            placeholder: "Realice una consulta..."
                          },
                          on: { keyup: _vm.keyup },
                          model: {
                            value: _vm.form.search,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "search", $$v)
                            },
                            expression: "form.search"
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(5)
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "form-inline mb-3" }, [
          _c("p", [_vm._v("Registros por página")]),
          _vm._v(" "),
          _c("div", { staticClass: "ktable-select" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.cantidadRegistros,
                    expression: "form.cantidadRegistros"
                  }
                ],
                attrs: { id: "cantidadRegistros" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "cantidadRegistros",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.submit
                  ]
                }
              },
              [
                _c("option", { domProps: { value: 10 } }, [_vm._v("10")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 30 } }, [_vm._v("30")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 50 } }, [_vm._v("50")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 100 } }, [_vm._v("100")])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mostrarTotales,
                  expression: "mostrarTotales"
                }
              ],
              staticClass: "totalesTable"
            },
            [
              _vm._v("\n          Total de registros: "),
              _c("strong", [_vm._v(_vm._s(_vm.totalRegistros))])
            ]
          ),
          _vm._v(" "),
          _vm.valorTotal != null && _vm.valorTotal != ""
            ? _c("p", { staticClass: "totalesTable" }, [
                _vm._v("\n          Total ($): "),
                _c("strong", [_vm._v(_vm._s(_vm.moneyFormat(_vm.valorTotal)))])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "table-selectable", class: _vm.classes }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.columns, function(column, index) {
                    return _c(
                      "th",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !column.hidden,
                            expression: "!column.hidden"
                          }
                        ],
                        key: "column" + index
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(column.display) +
                            "\n              "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.editButton ||
                            _vm.deleteButton ||
                            _vm.buttons.length > 0 ||
                            _vm.changeButton,
                          expression:
                            "\n                  editButton ||\n                  deleteButton ||\n                  buttons.length > 0 ||\n                  changeButton\n                "
                        }
                      ]
                    },
                    [_vm._v("\n                Acciones\n              ")]
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.rows, function(row, index) {
                  return _c(
                    "tr",
                    {
                      key: "row" + index,
                      class: {
                        "tr--pending":
                          row.tiene_items_pendientes &&
                          !(row.estado == _vm.estadoCancelado),
                        "tr--issued":
                          row.estado == "C" ||
                          (row.tiene_abono_entrada &&
                            !(row.estado == _vm.estadoCancelado)),
                        "tr--canceled":
                          row.estado == _vm.estadoCancelado ||
                          (row.movimiento != null &&
                            row.movimiento.tipo_documento === "EB"),
                        "tr--authorized":
                          row.estado == _vm.estadoAutorizado ||
                          (row.movimiento != null &&
                            row.movimiento.tipo_documento === "IB")
                      },
                      on: {
                        dblclick: function($event) {
                          _vm.currentIndex = index
                          _vm.seleccionar(row)
                        }
                      }
                    },
                    [
                      _vm._l(_vm.columns, function(column, ix) {
                        return _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !column.hidden,
                                expression: "!column.hidden"
                              }
                            ],
                            key: "cell" + index + ix
                          },
                          [
                            column.input &&
                            column.type !== "checkbox" &&
                            column.type !== "radio"
                              ? _c("input-field", {
                                  attrs: {
                                    id: "cell" + index + ix,
                                    type: column.type
                                  },
                                  on: {
                                    keyup: function($event) {
                                      return _vm.emitirInputs(_vm.rows)
                                    }
                                  },
                                  model: {
                                    value: row[column.value],
                                    callback: function($$v) {
                                      _vm.$set(row, column.value, $$v)
                                    },
                                    expression: "row[column.value]"
                                  }
                                })
                              : column.input
                              ? _c(
                                  "label",
                                  { attrs: { for: "cell" + index + ix } },
                                  [
                                    column.type === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row[column.value],
                                              expression: "row[column.value]"
                                            }
                                          ],
                                          attrs: {
                                            id: "cell" + index + ix,
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              row[column.value]
                                            )
                                              ? _vm._i(
                                                  row[column.value],
                                                  null
                                                ) > -1
                                              : row[column.value]
                                          },
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$a = row[column.value],
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        row,
                                                        column.value,
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        row,
                                                        column.value,
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    row,
                                                    column.value,
                                                    $$c
                                                  )
                                                }
                                              },
                                              function($event) {
                                                return _vm.emitirInputs(
                                                  _vm.rows
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      : column.type === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row[column.value],
                                              expression: "row[column.value]"
                                            }
                                          ],
                                          attrs: {
                                            id: "cell" + index + ix,
                                            type: "radio"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              row[column.value],
                                              null
                                            )
                                          },
                                          on: {
                                            change: [
                                              function($event) {
                                                return _vm.$set(
                                                  row,
                                                  column.value,
                                                  null
                                                )
                                              },
                                              function($event) {
                                                return _vm.emitirInputs(
                                                  _vm.rows
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row[column.value],
                                              expression: "row[column.value]"
                                            }
                                          ],
                                          attrs: {
                                            id: "cell" + index + ix,
                                            type: column.type
                                          },
                                          domProps: {
                                            value: row[column.value]
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.emitirInputs(_vm.rows)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                row,
                                                column.value,
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c("span")
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !column.input,
                                        expression: "!column.input"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        column.prefijo != undefined ? "$" : ""
                                      ) +
                                        _vm._s(
                                          column.numeric &&
                                            _vm.lodash.get(
                                              row,
                                              column.value
                                            ) !== undefined &&
                                            _vm.lodash.get(
                                              row,
                                              column.value
                                            ) !== null
                                            ? parseFloat(
                                                _vm.lodash.get(
                                                  row,
                                                  column.value
                                                )
                                              ).toLocaleString(_vm.locale)
                                            : _vm.lodash.get(row, column.value)
                                        )
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.editButton ||
                                _vm.deleteButton ||
                                _vm.buttons.length > 0 ||
                                _vm.changeButton,
                              expression:
                                "\n                  editButton ||\n                  deleteButton ||\n                  buttons.length > 0 ||\n                  changeButton\n                "
                            }
                          ],
                          staticClass: "table-actions"
                        },
                        [
                          _vm.changeButton && index > 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn-primary btn--text",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.subir(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-arrow-up" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.changeButton && index < _vm.rows.length - 1
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn-primary btn--text",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.bajar(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-arrow-down" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.editButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn-info btn--text",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.currentIndex = index
                                      _vm.editar(row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-edit" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.deleteButton &&
                          (!_vm.soloAnulacion ||
                            (_vm.soloAnulacion && row.estado !== "A"))
                            ? _c(
                                "button",
                                {
                                  class: {
                                    "btn-danger btn--text":
                                      (row.estado == "A" &&
                                        !_vm.esNotaDeDebito) ||
                                      row.estado == 1 ||
                                      (_vm.esNotaDeDebito &&
                                        row.estado == "E") ||
                                      row.estado === "P",
                                    "btn-success btn--text":
                                      row.estado == "I" || row.estado == 0
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.currentIndex = index
                                      _vm.eliminar(row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash-o" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.buttons, function(button, index) {
                            return _c(
                              "button",
                              {
                                key: index,
                                staticClass: "btn--text",
                                class: button.class,
                                attrs: { type: "button", title: button.title },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit(button.event, row)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa",
                                  class: button.icon
                                }),
                                button.text !== ""
                                  ? _c("span", [_vm._v(_vm._s(button.text))])
                                  : _vm._e()
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rows.length === 0,
                        expression: "rows.length === 0"
                      }
                    ]
                  },
                  [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan:
                            _vm.columns.length +
                            (_vm.editButton || _vm.deleteButton ? 1 : 0)
                        }
                      },
                      [_c("strong", [_vm._v("No hay datos.")])]
                    )
                  ]
                )
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ktable-pagination" }, [
          _c(
            "p",
            {
              staticClass: "ktable-pagination__button",
              attrs: {
                disabled: _vm.form.currentPage == 0 || _vm.form.currentPage == 1
              }
            },
            [
              _c(
                "a",
                { attrs: { href: "#" }, on: { click: _vm.anteriorPagina } },
                [
                  _c("i", { staticClass: "fa fa-chevron-left" }),
                  _c("span", [_vm._v("Anterior")])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "ktable-pagination__button",
              attrs: {
                disabled:
                  _vm.form.currentPage == _vm.totalPages || _vm.totalPages == 1
              }
            },
            [
              _c(
                "a",
                { attrs: { href: "#" }, on: { click: _vm.siguientePagina } },
                [
                  _c("span", [_vm._v("Siguiente")]),
                  _c("i", { staticClass: "fa fa-chevron-right" })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v("Páginas")]),
          _vm._v(" "),
          _c("div", { staticClass: "ktable-select" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.currentPage,
                    expression: "form.currentPage"
                  }
                ],
                attrs: { id: "paginaActual" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "currentPage",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.submit
                  ]
                }
              },
              [
                _c(
                  "option",
                  { attrs: { disabled: "" }, domProps: { value: 0 } },
                  [_vm._v("...")]
                ),
                _vm._v(" "),
                _vm._l(_vm.totalPages, function(i) {
                  return _c(
                    "option",
                    { key: "pages" + i, domProps: { value: i } },
                    [_vm._v("\n              " + _vm._s(i) + "\n            ")]
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("de " + _vm._s(_vm.totalPages))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn-info", attrs: { type: "submit" } },
      [
        _c("i", { staticClass: "fa fa-search" }),
        _vm._v(" "),
        _c("span", [_vm._v("Buscar")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Estados:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Estados:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Formato:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Fecha:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn-info btn--bigger", attrs: { type: "submit" } },
      [
        _c("i", { staticClass: "fa fa-search" }),
        _vm._v(" "),
        _c("span", [_vm._v("Buscar")])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e86a0e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e86a0e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/KTable.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0e86a0e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/KTable.vue
// module chunks = 0